import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');
dayjs.extend(relativeTime);
export default value => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  if (dayjs().diff(dayjs(value), 'hour') <= 72) {
    return dayjs().from(dayjs(value));
  } else {
    return dayjs(value).format('YYYY-MM-DD');
  }
};



// WEBPACK FOOTER //
// ./src/filters/timeago.js